import { Radio, Space } from 'antd-mobile';
import React, { forwardRef, useMemo } from 'react';
import { filterCssProperties, prefixCls } from '../../utils/style';
import './index.scss';
import { IndeterminateIcon } from '../../utils/icon';
const CascadeRadio = (props, ref) => {
    const { value, options, subContainerStyle, style, onChange } = props;
    const spaceCss = {
        '--gap': '12px',
        '--gap-vertical': '6px',
        ...filterCssProperties(style, ['--gap-horizontal', '--gap-vertical']),
    };
    if (style?.['--space-gap']) {
        spaceCss['--gap'] = style['--space-gap'];
    }
    const radioCss = {
        '--font-size': '13px',
        '--gap': '4px',
        ...filterCssProperties(style, ['--font-size', '--gap', '--icon-size']),
    };
    const selected = useMemo(() => {
        if (value?.[0] != undefined) {
            return options.find((o) => o.value === value[0]);
        }
        return undefined;
    }, [value]);
    const renderIcon = (checked) => {
        return (React.createElement("div", { className: `${prefixCls}cascade-radio-icon` }, checked && React.createElement(IndeterminateIcon, null)));
    };
    return (React.createElement("div", { className: `${prefixCls}cascade-radio`, style: style, ref: ref },
        React.createElement(Radio.Group, { value: value?.[0], onChange: (v) => onChange?.([v]) },
            React.createElement(Space, { direction: "horizontal", wrap: true, style: spaceCss }, options?.map((option, index) => {
                return (React.createElement(Radio, { key: index, value: option.value, style: radioCss, icon: renderIcon }, option.label));
            }))),
        selected?.children && (React.createElement("div", { style: subContainerStyle, className: `${prefixCls}cascade-radio-sub` },
            React.createElement(Radio.Group, { value: value?.[1] ?? null, onChange: (subV) => onChange?.([selected.value, subV]) },
                React.createElement(Space, { direction: "horizontal", wrap: true, style: spaceCss }, selected.children.map((sub, i) => {
                    return (React.createElement(Radio, { key: i, value: sub.value, style: radioCss, icon: renderIcon }, sub.label));
                })))))));
};
export default forwardRef(CascadeRadio);
